import useBeautyFilterBanubaStore from 'stores/beautyFilter/beautyFilterBanubaStore';
import ToastBridge from 'bridges/toastBridge';
import { BeautyFilterMenuItem } from 'types/beautyFilter';

// 필터 UI 진입을 막고 토스트로 안내하는 가드.
// - banubaUnavailable: Banuba 초기화가 타임아웃/실패 → 뷰티·메이크업만 막는다 (무드/스티커는 Banuba 무관)
// - gpuPassthrough: 네이티브가 GPU passthrough(리드백 회피) 중 → 무드·스티커까지 전부 막는다 (네이티브가 적용을 무시하므로).
//   passthrough 기기는 main.js가 뷰티필터 진입 버튼 자체를 숨기므로 이 가드는 모달이 열린 채 판정이 바뀐 경우의 안전망이다.
const useBanubaGuard = () => {
  const banubaUnavailable = useBeautyFilterBanubaStore((state) => state.banubaUnavailable);
  const gpuPassthrough = useBeautyFilterBanubaStore((state) => state.gpuPassthrough);

  const showUnavailableToast = () => {
    ToastBridge.add({ text: brsc.beauty_filter_tab_unavailable });
  };

  // 차단 조건 한 곳: passthrough면 전부, 아니면 Banuba 의존 항목만 banubaUnavailable에 따라
  const isBlocked = (requiresBanuba: boolean) => gpuPassthrough || (requiresBanuba && banubaUnavailable);

  const isItemDisabled = (item: BeautyFilterMenuItem) => isBlocked(!!item.requiresBanuba);

  // 탭 컨텐츠 컨테이너용 클릭 가드 (capture 단계에서 자식 onClick 차단)
  const guardClick = (requiresBanuba: boolean) => (e: React.MouseEvent) => {
    if (!isBlocked(requiresBanuba)) return;
    e.stopPropagation();
    showUnavailableToast();
  };

  // Banuba 의존 탭(뷰티·메이크업)용
  const guardBanubaClick = guardClick(true);
  // Banuba 무관 탭(무드·스티커)용
  const guardPassthroughClick = guardClick(false);

  return { banubaUnavailable, gpuPassthrough, showUnavailableToast, isItemDisabled, guardBanubaClick, guardPassthroughClick };
};

export default useBanubaGuard;
